<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useConfigStore } from "@core/stores/config.store"

// ================================
// COMPOSABLES
// ================================
const configStore = useConfigStore()

// ================================
// COMPUTED
// ================================
/** URL du logo « full » du scope courant (équivalent legacy `config/getScope` → assets.logos.full). */
const getLogo = computed(() => configStore.getScopeLogoFull)

/** Texte alternatif : marque ou nom du scope. */
const getScopeBrandAlt = computed(
    () => configStore.getScopeBrand ?? configStore.getScopeName ?? "Homeys"
)
</script>

<template>
    <!-- ================================ -->
    <!-- EN-TÊTE LANDING (identité scope, aligné layout validation legacy) -->
    <!-- ================================ -->
    <header
        class="consent-request-scope-header box-border flex min-h-[6.125rem] w-full shrink-0 items-center justify-center border-b border-t border-primary-100 px-4 py-8"
    >
        <img
            v-if="getLogo"
            :src="getLogo"
            :alt="getScopeBrandAlt"
            class="mx-auto h-[35px] max-w-full select-none object-contain"
            height="35"
            draggable="false"
        />
    </header>
</template>
